import React from 'react';
import { Dialog } from "primereact/dialog";
import { Button } from 'reactstrap';
import Select from 'react-select';
import './styleTransfer.css';

export const DialogTransfer = ({
    modalTransfer,
    closeTransfer,
    listSellers,
    handleInputChange,

    id_seller_origin, id_seller_destiny, handleTransfer,
    showConfirm, setShowConfirm, doctorCount, errorTransfer, handleShowConfirm, listSellerAll
}) => {

    console.log("🦄 listSellerAll", listSellerAll);

    const customSelectStyles = {
        control: (base, state) => ({
            ...base,
            borderRadius: "10px",
            border: state.isFocused ? "1px solid #0d3c5f" : "1px solid #e5e7eb",
            boxShadow: "none",
            backgroundColor: "#f8fafc",
            padding: "2px",
            minHeight: "42px",
            "&:hover": {
                borderColor: "#0d3c5f"
            }
        }),
        placeholder: (base) => ({
            ...base,
            color: "#9ca3af",
            fontSize: "14px"
        }),
        singleValue: (base) => ({
            ...base,
            color: "#374151"
        }),
        menu: (base) => ({
            ...base,
            borderRadius: "10px",
            overflow: "hidden"
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? "#f1f5f9" : "white",
            color: "#374151",
            padding: "10px"
        })
    };

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>

            {!showConfirm ? (
                <>


                    <Button
                        color="secondary"
                        size="sm"
                        onClick={handleShowConfirm}
                    >
                        Confirmar transferencia
                    </Button>
                    <Button
                        color="danger"
                        size="sm"
                        onClick={closeTransfer}
                    >
                        Cancelar
                    </Button>
                </>
            ) : (
                <>
                    <Button
                        color="secondary"
                        size="sm"
                        onClick={() => {
                            handleTransfer();
                            setShowConfirm(false);
                        }}
                        disabled={doctorCount === 0}

                    >
                        Sí, confirmar
                    </Button>
                    <Button
                        color="danger"
                        size="sm"
                        onClick={closeTransfer}
                    >
                        Cancelar
                    </Button>
                </>
            )}

        </div>
    );

    const sellerOriginName = listSellers.find(x => x.value === id_seller_origin)?.label || "";

    const sellerDestinyName = listSellers.find(x => x.value === id_seller_destiny)?.label || "";

    const formatOptionLabel = (option) => {
        const isDeleted = option.deleted;

        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                    width: "100%"
                }}
            >
                <span
                    style={{
                        fontSize: "12px",
                        // fontWeight: 500,
                        color: isDeleted ? "#9ca3af" : "#111827",
                        textDecoration: isDeleted ? "line-through" : "none"
                    }}
                >
                    {option.label}
                </span>

                <span
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        fontSize: "10px",
                        padding: "3px 10px",
                        borderRadius: "999px",
                        fontWeight: 600,
                        letterSpacing: "0.5px",
                        backgroundColor: isDeleted ? "#fee2e2" : "#dcfce7",
                        color: isDeleted ? "#991b1b" : "#065f46",
                        border: isDeleted
                            ? "1px solid #fecaca"
                            : "1px solid #bbf7d0"
                    }}
                >
                    <i
                        className={`pi ${isDeleted ? "pi-times-circle" : "pi-check-circle"}`}
                        style={{ fontSize: "10px" }}
                    ></i>
                    {isDeleted ? "ELIMINADO" : "ACTIVO"}
                </span>
            </div>
        );
    };

    return (
        <Dialog
            visible={modalTransfer}
            onHide={closeTransfer}
            modal
            closable={false}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-suitcase f-24"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Transferir cartera de clientes
                            </div>


                        </div>

                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v2`}
            footer={footer}
        >
            <div className="transfer-container">
                <div className="transfer-card">
                    <small>Vendedor origen</small>
                    <Select
                        name="id_seller_origin"
                        value={listSellerAll.find(x => x.value === id_seller_origin) || null}
                        options={listSellerAll}
                        placeholder="Seleccionar..."
                        isClearable
                        formatOptionLabel={formatOptionLabel}

                        menuPortalTarget={document.body}
                        styles={{ customSelectStyles, menuPortal: base => ({ ...base, zIndex: 9999999 }) }}
                        classNamePrefix="input-admision"
                        onChange={(selected) =>
                            handleInputChange({
                                target: {
                                    name: "id_seller_origin",
                                    value: selected ? selected.value : 0
                                }
                            })
                        }
                    />
                    {errorTransfer.origin && (
                        <div style={{
                            marginTop: "12px",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            background: "#fff1f2",
                            color: "#b91c1c",
                            fontSize: "13px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px"
                        }}>
                            <i className="pi pi-info-circle"></i>
                            {errorTransfer.origin}
                        </div>
                    )}


                </div>

                <div className="arrow-transfer">
                    <i className="pi pi-arrow-down"></i>
                </div>

                <div className="transfer-card">
                    <small>Vendedor destino</small>
                    <Select
                        name="id_seller_destiny"
                        value={listSellers.find(x => x.value === id_seller_destiny) || null}
                        options={listSellers}
                        placeholder="Asignar a..."
                        isClearable
                        onChange={(selected) =>
                            handleInputChange({
                                target: {
                                    name: "id_seller_destiny",
                                    value: selected ? selected.value : 0
                                }
                            })
                        }
                        menuPortalTarget={document.body}
                        styles={{ customSelectStyles, menuPortal: base => ({ ...base, zIndex: 9999999 }) }}
                        classNamePrefix="input-admision"
                    />

                    {errorTransfer.destiny && (
                        <div style={{
                            marginTop: "12px",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            background: "#fff1f2",
                            color: "#b91c1c",
                            fontSize: "13px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px"
                        }}>
                            <i className="pi pi-info-circle"></i>
                            {errorTransfer.destiny}
                        </div>
                    )}

                </div>


                {showConfirm && doctorCount !== null && (
                    <div className={`security-box ${doctorCount === 0 ? "warning-yellow" : "warning"} mt-3`}>
                        <div className="security-icon">
                            <i className="pi pi-exclamation-triangle"></i>
                        </div>

                        <div className="security-content">
                            <strong className='mr-2'>
                                {doctorCount === 0 ? "Sin médicos asignados" : "Advertencia"}
                            </strong>

                            <p>
                                {doctorCount === 0 ? (
                                    <>
                                        El Vendedor <b>{sellerOriginName}</b> no tiene médicos asignados.
                                        <br /><br />
                                        <b>Selecciona otro vendedor.</b>
                                    </>
                                ) : (
                                    <>
                                        <p>
                                            <b>{sellerOriginName}</b> tiene asignados <b>{doctorCount}</b> médicos.
                                            <br />
                                            ¿Estás seguro que deseas transferir la cartera de clientes al nuevo vendedor <b>{sellerDestinyName}</b>?
                                            <br />
                                            Esta acción <b>no se puede deshacer</b>.
                                        </p>
                                    </>
                                )}
                            </p>
                        </div>
                    </div>
                )}
            </div>

        </Dialog>
    );
};